import Vue from 'vue'
import Vuex, { StoreOptions, Store } from 'vuex'

import { TenderWebApi } from '@/services/api/baseTradeApi'

//data
import { SignInfo, SignInfoRequest } from '@/data/crypto-sign-info-types/types'
import initialSignInfo from './initialState'

Vue.use(Vuex)

const storeOptions: StoreOptions<RootStateSignInfo> = {
  state: {
    signInfo: initialSignInfo as SignInfo
  },
  actions: {
    async getCryptoSignInfo({ commit }, requestData: SignInfoRequest) {
      try {
        const { data } = await TenderWebApi.getCryptoSignInfo(requestData);
        if(data.IsSuccess) {
          commit('setSignInfo', data.Response);
        }
        else if(data.Message) {
          commit('setSignInfoError', data.Message);
        }
        else {
          commit('setSignInfoError', 'Произошла одна или более ошибок');
        }
      }
      catch(error) {
        commit('setSignInfoError', `Запрос вероятно отвергнут. ${error}`);
        console.error(error, 'Произошла ошибка при попытке получить данные подписания')
      }      
    }
  },
  mutations: {
    setSignInfo(state: RootStateSignInfo, signInfo: SignInfo) {
      state.signInfo = signInfo
      state.signInfo.Error = null;
    },
    setSignInfoError(state: RootStateSignInfo, errorMessage: string) {
      state.signInfo.Error = { Message: errorMessage }
    }
  },
};

const store: Store<RootStateSignInfo> = new Vuex.Store(storeOptions)

export default store;
